import React, { Component } from 'react';


declare global {
  interface Window {
    OpenSeadragon: any
  }
}


interface Props {
  filename: string;
  hideModalImage: any;
}


export class ModalImage extends Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    this.handleEscKey = this.handleEscKey.bind(this);
  }

  componentDidMount() {
    const { filename } = this.props;
    if (filename.indexOf(".gif") < 0) {

      let tileSources = `https://iiif.mused.org/${filename}/info.json`;
      console.log("modal mounted")

      const viewer = window.OpenSeadragon({
        id: 'viewer',
        tileSources: tileSources,
        showZoomControl: false,
        showHomeControl: false,
        showFullPageControl: false,
        showRotationControl: false,
        viewportMargins: {
          bottom: 60,
          top: 60,
          left: 60,
          right: 60
        },
        gestureSettingsMouse: {
          clickToZoom: false,
          dblClickToZoom: true
        },
        defaultZoomLevel: 0,
        visibilityRatio: 0.8
      });
    }

    // bind escape key
    document.addEventListener("keydown", this.handleEscKey, false);
  }

  handleEscKey(event){
    if (event.key === "Escape") {
      this.props.hideModalImage();
    }
  }

  componentWillUnmount(){
    document.removeEventListener("keydown", this.handleEscKey, false);
  }

  render() {
    const { filename } = this.props;

    return (
      <div id="modal_viewer" className="fixed top-0 bottom-0 left-0 right-0 h-screen w-screen z-50 pointer-events-auto">
        <div className="h-screen w-screen bg-theme-900 opacity-80" onClick={this.props.hideModalImage.bind(this)}></div>

        <button className="fixed top-20 right-16 z-50 cursor-pointer text-white" onClick={this.props.hideModalImage.bind(this)}>
          <svg version="1.1" width="36" height="36" viewBox="0 0 24 24" fill="currentColor"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>
        </button>

        <div id="viewer_outer" >
          {filename.indexOf(".gif") >= 0 ?
            <div
              id="viewer"
              className="fixed top-0 bottom-0 left-0 right-0 h-screen w-screen z-40"
            >
              <img src={`https://static.mused.org/${filename}`} className="w-full h-full object-contain" style={{ padding: "10%" }} />
            </div>
          :
            <div id="viewer" className="fixed top-0 bottom-0 left-0 right-0  h-screen w-screen z-40"></div>
          }
        </div>
      </div>
    );
  }
}
